import React from "react";
import AdminClientHeader from "modules/admin/clients/components/header/AdminClientHeader";
import "./SavedRoutesPage.scss";

const SavedRoutesPage = () => {
  const breadCrumbs = [{ text: "SAVED ROUTES" }];

  return (
    <div className="saved-routes-page">
      <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />
      <div className="content-wrapper">
        <div className="coming-soon-container">
          <h2 className="coming-soon-title">Coming Soon</h2>
          <p className="coming-soon-message">
            The Saved Routes feature is currently under development and will be available
            soon.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SavedRoutesPage;
